/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { eventDetailPayoutListConfig } from '../../config/eventDetail.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ISettingsPayoutListListPluginMethods extends IPluginMethodMap {
  getSettingsPayoutListListSync(args?: any): any;
}

export class SettingsPayoutListListPlugin implements IAgentPlugin {
  readonly methods: ISettingsPayoutListListPluginMethods;

  constructor() {
    this.methods = {
      getSettingsPayoutListListSync:
        this.getSettingsPayoutListListSync.bind(this),
    };
  }

  async getSettingsPayoutListListSync(args?: any) {
    return {
      buttons: await this.getButtons(eventDetailPayoutListConfig?.buttons),
    };
  }

  private async getButtons(data: any) {
    let whoami = await getWhoamiSrv()?.whoAmI();
    if (whoami?.whoami === 'RISK_CAPITAL') {
      return eventDetailPayoutListConfig?.buttons;
    } else {
      return [];
    }
  }
}
